import { getPlatformInfo, PlatformEnum } from '@tencent/wphk-platform-adapter';

// 常量定义
const DEFAULT_DESIGN_WIDTH = 375;
const MAX_REM_RATIO = 200;

/**
 * 设置响应式 rem 单位
 * @param designWidth 设计稿基准宽度，默认为 375px
 */
export function resizeRem(designWidth?: number) {
  const baseWidth = designWidth || DEFAULT_DESIGN_WIDTH;
  const docElement = document.documentElement;
  const platform = getPlatformInfo();

  // 如果没有文档元素，直接返回
  if (!docElement) return;

  const handleResize = () => {
    const { clientWidth } = docElement;

    // 如果没有客户端宽度，直接返回
    if (!clientWidth) return;

    const remRatio = 100 * (clientWidth / baseWidth);
    const finalRemRatio = Math.min(remRatio, MAX_REM_RATIO);

    docElement.style.fontSize = `${finalRemRatio}px`;
  };

  // 根据平台类型添加不同的事件监听器
  if (platform.platformType === PlatformEnum.LiteApp) {
    lite.addEventListener('resize', handleResize);
  } else {
    const resizeEvent = 'orientationchange' in window ? 'orientationchange' : 'resize';
    window.addEventListener(resizeEvent, handleResize);
  }

  // 初始化设置
  handleResize();
}
